module.exports = __webpack_public_path__ + "img/28.0b7fc3ac.jpg";